import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },
      { path: 'user', name: 'User', meta: { name: '用户信息' }, component: () => import('../views/manager/User') },
      { path: 'userPerson', name: 'UserPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/UserPerson') },
      { path: 'acquirer', name: 'Acquirer', meta: { name: '收购员信息' }, component: () => import('../views/manager/Acquirer') },
      { path: 'acqApply', name: 'AcqApply', meta: { name: '收购员申请' }, component: () => import('../views/manager/AcqApply') },
      { path: 'userAcqApply', name: 'UserAcqApply', meta: { name: '收购员申请' }, component: () => import('../views/manager/UserAcqApply') },
      { path: 'acqPerson', name: 'AcqPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AcqPerson') },
      { path: 'market', name: 'Market', meta: { name: '农产品收购信息' }, component: () => import('../views/manager/Market') },
      { path: 'records', name: 'Records', meta: { name: '出售记录' }, component: () => import('../views/manager/Records') },
       { path: 'acqRecords', name: 'AcqRecords', meta: { name: '收购记录' }, component: () => import('../views/manager/AcqRecords') },
      { path: 'acqColum', name: 'AcqColum', meta: { name: '收购栏' }, component: () => import('../views/manager/acqColum') },
      { path: 'saleColum', name: 'SaleColum', meta: { name: '出售栏' }, component: () => import('../views/manager/SaleColum') },
      { path: 'map', name: 'Map', meta: { name: '地图农产品收购' }, component: () => import('../views/manager/Map') },
      { path: 'knowledge', name: 'Knowledge', meta: { name: '农产品科普' }, component: () => import('../views/manager/Knowledge') },
      { path: 'knowledgeDetail', name: 'KnowledgeDetail', meta: { name: '农产品科普详情' }, component: () => import('../views/manager/KnowledgeDetail') },
      { path: 'donate', name: 'Donate', meta: { name: '物资捐赠' }, component: () => import('../views/manager/Donate') },
      { path: 'comment', name: 'Comment', meta: { name: '留言信息' }, component: () => import('../views/manager/Comment') },
      { path: 'userComment', name: 'UserComment', meta: { name: '在线留言' }, component: () => import('../views/manager/UserComment') },
      { path: 'dashboard', name: 'Dashboard', meta: { name: '数据统计' }, component: () => import('../views/manager/Dashboard') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]



// 这段代码是在Vue.js中使用Vue Router库创建一个路由器实例。其中，参数对象包括了三个属性：
// 1. mode：指定路由的模式，包括"hash"和"history"两种。"hash"模式会在URL中加入#号，而"history"模式则不会。
// 2. base：指定应用的基路径。默认情况下，它为"/"，即应用的根路径。
// 3. routes：指定路由规则，即路由路径和对应的组件。
// 通过创建一个路由器实例，可以让Vue应用支持路由功能，实现单页应用的页面切换效果。具体的路由配置可以在routes属性中定义。
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 注：不需要前台的项目，可以注释掉该路由守卫
// 路由守卫
// router.beforeEach((to ,from, next) => {
//   let user = JSON.parse(localStorage.getItem("ap-user") || '{}');
//   if (to.path === '/') {
//     if (user.role) {
//       if (user.role === 'USER') {
//         next('/front/home')
//       } else {
//         next('/home')
//       }
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

export default router
